import DetailsCard from "@/components/DetailsCard";
import { toFormat } from "@/lib/dateHelpers";
import { formatEnumLabel } from "@/pages/billing/finance/commission/_utils";
import type { PersonGrpIaaSummary } from "../types";

interface Props {
  summary: PersonGrpIaaSummary | null;
}

export default function IaaSummaryCard({ summary }: Props) {
  if (!summary) {
    return (
      <DetailsCard
        heading="Allocation agreement"
        caption="No IAA on file for this member."
        options={[]}
        skipRenderWithEmptyOptions={false}
      />
    );
  }

  return (
    <DetailsCard
      heading="Current allocation"
      options={[
        { overline: "Facility", headline: summary.facilityName, iconName: "location_on" },
        { overline: "Receiver PGA ID", headline: summary.receiverPgaId, iconName: "badge" },
        { overline: "Split", headline: `${summary.splitPercent}%`, iconName: "percent" },
        { overline: "Status", headline: formatEnumLabel(summary.status), iconName: "info" },
        { overline: "Effective", headline: toFormat(summary.effectiveDate), iconName: "today" }
      ]}
    />
  );
}
